export const SCHOOL_EDIT_STATES = Object.freeze({
  READ_ONLY: "READ_ONLY",
  PRE_EXECUTION: "PRE_EXECUTION",
  POST_EXECUTION_UDISE_EDITABLE: "POST_EXECUTION_UDISE_EDITABLE",
  POST_EXECUTION_LOCKED: "POST_EXECUTION_LOCKED",
});

export const SCHOOL_EDIT_ALLOWED_ROLES = Object.freeze([
  "Super Admin",
  "MIS Team Admin",
]);

export const LOCKED_EDIT_STATES = Object.freeze([
  SCHOOL_EDIT_STATES.READ_ONLY,
  SCHOOL_EDIT_STATES.POST_EXECUTION_LOCKED,
]);

export const EDITABLE_FIELDS_BY_STATE = Object.freeze({
  [SCHOOL_EDIT_STATES.PRE_EXECUTION]: [
    "school_name",
    "udise_code",
    "board",
    "school_type",
    "branch_name",
    "address",
    "country",
    "state",
    "district",
    "city",
    "pincode",
    "email",
  ],
  [SCHOOL_EDIT_STATES.POST_EXECUTION_UDISE_EDITABLE]: ["udise_code"],
  [SCHOOL_EDIT_STATES.POST_EXECUTION_LOCKED]: [],
  [SCHOOL_EDIT_STATES.READ_ONLY]: [],
});

export const SCHOOL_TYPE_OPTIONS = Object.freeze([
  { label: "Public", value: "Public" },
  { label: "Private", value: "Private" },
]);

export const BASIC_DETAIL_FIELDS = Object.freeze([
  { key: "school_id", label: "School ID", type: "text", alwaysReadOnly: true },
  {
    key: "school_name",
    label: "School Name",
    type: "text",
    required: true,
    placeholder: "Enter school name",
  },
  {
    key: "udise_code",
    label: "UDISE Code",
    type: "text",
    required: true,
    placeholder: "Enter 11-digit UDISE code",
  },
  {
    key: "school_type",
    label: "School Type",
    type: "select",
    required: true,
    options: SCHOOL_TYPE_OPTIONS,
    placeholder: "Select school type",
  },
  {
    key: "board",
    label: "Board",
    type: "text",
    required: true,
    placeholder: "Enter board",
  },
  {
    key: "branch_name",
    label: "Branch Name",
    type: "text",
    required: true,
    placeholder: "Enter branch name",
  },
  {
    key: "address",
    label: "Address",
    type: "text",
    required: true,
    placeholder: "Enter address",
  },
  {
    key: "country",
    label: "Country",
    type: "select",
    required: true,
    geoOptionsKey: "countryOptions",
    placeholder: "Select country",
  },
  {
    key: "state",
    label: "State",
    type: "select",
    required: true,
    geoOptionsKey: "stateOptions",
    placeholder: "Select state",
  },
  {
    key: "district",
    label: "District",
    type: "select",
    required: true,
    geoOptionsKey: "districtOptions",
    placeholder: "Select district",
  },
  {
    key: "city",
    label: "City",
    type: "select",
    required: true,
    geoOptionsKey: "cityOptions",
    placeholder: "Select city",
  },
  {
    key: "pincode",
    label: "Pincode",
    type: "text",
    required: true,
    placeholder: "Enter 6-digit pincode",
  },
  {
    key: "phone",
    label: "Phone",
    type: "text",
    alwaysReadOnly: true,
    formatDisplay: (school) =>
      school.phone ? `${school.isd_code || ""} ${school.phone}`.trim() : "N/A",
  },
  {
    key: "email",
    label: "Email",
    type: "text",
    required: true,
    placeholder: "Enter email address",
  },
  {
    key: "invitation_code",
    label: "Invitation Code",
    type: "text",
    alwaysReadOnly: true,
    formatDisplay: (school) =>
      school.invitation_code || school.activation_code || "N/A",
  },
  { key: "fee", label: "Fee", type: "text", viewOnly: true },
  { key: "tier", label: "Tier", type: "text", viewOnly: true },
  { key: "category", label: "Category", type: "text", viewOnly: true },
]);
